export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAFklEQVR42mNgYGD4TyEeNWDUgOFgAABQqr9Bfk1CqQAAAABJRU5ErkJggg=="